import { render, staticRenderFns } from "./SendRequestModal.vue?vue&type=template&id=5232ec97&scoped=true&"
import script from "./SendRequestModal.vue?vue&type=script&lang=js&"
export * from "./SendRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./SendRequestModal.vue?vue&type=style&index=0&id=5232ec97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5232ec97",
  null
  
)

export default component.exports